if (!customElements.get('hero-alt-slider')) {
  customElements.define(
    'hero-alt-slider',
    class HeroAlt extends HTMLElement {
      constructor() {
        super();
      }
    
      connectedCallback() {
        const swiper_el = this.querySelector('[data-swiper]');
        const fraction_current = this.querySelector('[data-fraction-current]');
        const fraction_total = this.querySelector('[data-fraction-total');

        fraction_total.innerHTML = swiper_el.swiper.slides.length;

        swiper_el.addEventListener('swiperslidechangetransitionstart', (event) => {
        const real_index = event.detail[0].realIndex;
        fraction_current.innerHTML = real_index + 1;
        });

        if (swiper_el.swiper.slides.length < 2) {
          const carousel_arrows = this.querySelector('[data-carousel-arrows]');
          const pagination_fraction = this.querySelector('[data-fraction-container]');
          const pagination_dots = this.querySelector('[data-pagination-dots]');

          if (carousel_arrows) carousel_arrows.classList.add('hidden');
          if (pagination_fraction) pagination_fraction.classList.add('hidden');
          if (pagination_dots) pagination_dots.classList.add('hidden');
        }
      }
    }
  )
}